import React, { useEffect } from 'react';
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import { ConfigEmpresaProvider } from './context/ConfigEmpresaContext';
import { CamposDinamicosProvider } from './context/CamposDinamicosContext';
import { EstadosProvider } from './context/EstadosContext';
import { EmpresaProvider } from './context/EmpresaContext';  // 🆕 Contexto de empresa con moneda
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
//import io from 'socket.io-client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import EmpresaAdmin from './pages/EmpresaAdmin';
import EmpresaForm from './pages/EmpresaForm';
import RegistrarNegocio from './pages/RegistrarNegocio';
import AprobarNegocios from './pages/AprobarNegocios';
import UsuarioAdmin from './pages/UsuarioAdmin';
import UsuarioForm from './pages/UsuarioForm';
import ServicioAdmin from './pages/ServicioAdmin';
import Mantenimiento from './pages/Mantenimiento';
import CrudPaises from './pages/CrudPaises';
import CrudRubros from './pages/CrudRubros';
import LocalesAdmin from './pages/LocalesAdmin';
import LocalForm from './pages/LocalForm';
import UsuariosHomeAdmin from './pages/UsuariosHomeAdmin';
import UsuarioHomeForm from './pages/UsuarioHomeForm';
import TrabajadoresAdmin from './pages/TrabajadoresAdmin';
import TrabajadorForm from './pages/TrabajadorForm';
import AsistenciaMasiva from './pages/AsistenciaMasiva';
import ServiciosAdmin from './pages/ServiciosAdmin';
import ServicioForm from './pages/ServicioForm';
import ClientesAdmin from './pages/ClientesAdmin';
import ClienteForm from './pages/ClienteForm';
import PeriodosAdmin from './pages/PeriodosAdmin';
import PeriodoForm from './pages/PeriodoForm';
import OrdenesServicioAdmin from './pages/OrdenesServicioAdmin';
import OrdenServicioForm from './pages/OrdenServicioForm';
import OrdenDetalleForm from './pages/OrdenDetalleForm';
import TableroControl from './pages/TableroControl';  // Importa el componente TableroControl
import AsignarTrabajadorForm from './pages/AsignarTrabajadorForm';
import MiEmpresa from './pages/MiEmpresa';
import MiEmpresaForm from './pages/MiEmpresaForm';
import AprobarServiciosAdmin from './pages/AprobarServiciosAdmin';
import AdminTools from './pages/AdminTools';
import { initializeSocket, disconnectSocket } from './services/socketService';
import LiquidacionAdmin from './pages/LiquidacionAdmin';
import PagosAdmin from './pages/PagosAdmin';
import RootRedirect from './pages/RootRedirect';

// Componentes Admin V2.1
import AdminDashboard from './pages/admin/dashboard/AdminDashboard';
import GestionEmpresasUnificada from './pages/admin/empresas/GestionEmpresasUnificada';
import GestionPlantillas from './pages/admin/mantenimiento/GestionPlantillas';
import GestionCamposGlobales from './pages/admin/mantenimiento/GestionCamposGlobales';
import GestionUsuarios from './pages/admin/usuarios/GestionUsuarios';
import FormularioUsuario from './pages/admin/usuarios/FormularioUsuario';
import GestionSuscripciones from './pages/admin/suscripciones/GestionSuscripciones';

// Dashboard Analytics
import DashboardAnalytics from './pages/DashboardAnalytics';

// Tracking Dashboard
import TrackingDashboard from './pages/TrackingDashboard';

// Suscripción
import MiPlan from './pages/Suscripcion/MiPlan';
import ConfirmacionPago from './pages/Suscripcion/Confirmacion';
import TrackingDashboardEnhanced from './pages/TrackingDashboardEnhanced';
import SeguimientoPublico from './pages/SeguimientoPublico';
import SeguimientoEntrega from './pages/SeguimientoEntrega';
import DeliveryRuta from './pages/Delivery/DeliveryRuta';

// Campos Dinámicos
import ConfiguracionCamposDinamicos from './pages/ConfiguracionCamposDinamicos';
import TrazabilidadOrden from './pages/TrazabilidadOrden';
import GestionCatalogoCampos from './pages/GestionCatalogoCampos';

// Campos Dinámicos - Super Admin
import GestionCatalogoCamposAdmin from './pages/admin/GestionCatalogoCampos';
import ConfiguracionCamposEmpresas from './pages/admin/ConfiguracionCamposEmpresas';




// Crear el tema
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    h1: {
      fontSize: '2rem',
    },
  },
});

function App() {
  useEffect(() => {
   // const socket = io('http://localhost:3000');
    const socket = initializeSocket();

    socket.on('connect', () => {
      console.log('Conectado al servidor de Socket.IO con ID:', socket.id);

      // Unirse a la sala de la empresa para recibir eventos en tiempo real
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        try {
          const userData = JSON.parse(storedUser);
          if (userData.id_empresa) {
            socket.emit('joinCompany', userData.id_empresa);
            console.log('🔌 PWA unida a sala company_' + userData.id_empresa);
          }
        } catch (e) {}
      }
    });

    socket.on('ordenActualizada', (data) => {
      console.log('🔔 Orden actualizada en tiempo real:', data);
    });

    return () => {
     disconnectSocket();
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <EmpresaProvider>
          <EstadosProvider>
            <ConfigEmpresaProvider>
              <CamposDinamicosProvider>
                <SocketProvider>
                <Router>
                <Routes>
                  {/* Ruta raíz - Redirige a /home si hay sesión, o a /login si no */}
                  <Route path="/" element={<RootRedirect />} />

                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/seguimiento/:token" element={<SeguimientoPublico />} />
                  <Route path="/seguimiento-entrega/:token" element={<SeguimientoEntrega />} />
                  <Route path="/admin" element={<ProtectedRoute allowedLevels={[1]}><AdminPage /></ProtectedRoute>}>
            {/* Dashboard */}
            <Route index element={<AdminDashboard />} />

            {/* Gestión de Empresas UNIFICADA */}
            <Route path="empresas" element={<GestionEmpresasUnificada />} />
            <Route path="empresas/crear" element={<EmpresaForm />} />
            <Route path="empresas/editar/:id" element={<EmpresaForm />} />

            {/* Usuarios del Sistema - V2.1 */}
            <Route path="usuarios" element={<GestionUsuarios />} />
            <Route path="usuarios/crear" element={<FormularioUsuario />} />
            <Route path="usuarios/editar/:id" element={<FormularioUsuario />} />

            {/* Servicios */}
            <Route path="servicios" element={<ServicioAdmin />} />

            {/* Mantenimiento */}
            <Route path="mantenimiento" element={<Mantenimiento />} />
            <Route path="mantenimiento/plantillas" element={<GestionPlantillas />} />
            <Route path="mantenimiento/campos" element={<GestionCamposGlobales />} />
            <Route path="mantenimiento/paises" element={<CrudPaises />} />
            <Route path="mantenimiento/rubros" element={<CrudRubros />} />

            {/* Campos Dinámicos V2 - Super Admin */}
            <Route path="catalogo-campos" element={<GestionCatalogoCamposAdmin />} />
            <Route path="campos-empresas" element={<ConfiguracionCamposEmpresas />} />
            <Route path="suscripciones" element={<GestionSuscripciones />} />

          </Route>
          <Route path="/home" element={<ProtectedRoute allowedLevels={[1, 2, 3]}><HomePage /></ProtectedRoute>}>
            {/* Dashboard Analytics como vista por defecto */}
            <Route index element={<DashboardAnalytics />} />
            <Route path="miempresa" element={<MiEmpresa />} />
            <Route path="miempresa/editar" element={<MiEmpresaForm />} />
            <Route path="usuarios" element={<UsuariosHomeAdmin />} />
            <Route path="usuarios/editar/:id" element={<UsuarioHomeForm />} />
            <Route path="locales" element={<LocalesAdmin />} />
            <Route path="locales/crear" element={<LocalForm />} />
            <Route path="locales/editar/:id" element={<LocalForm />} />
            <Route path="trabajadores" element={<TrabajadoresAdmin />} />
            <Route path="trabajadores/crear" element={<TrabajadorForm />} />
            <Route path="trabajadores/editar/:id" element={<TrabajadorForm />} />
            <Route path="trabajadores/asistencia" element={<AsistenciaMasiva />} />
            <Route path="servicios" element={<ServiciosAdmin />} />
            <Route path="servicios/crear" element={<ServicioForm />} />
            <Route path="servicios/editar/:id" element={<ServicioForm />} />
            <Route path="clientes" element={<ClientesAdmin />} />
            <Route path="clientes/crear" element={<ClienteForm />} />
            <Route path="clientes/editar/:id" element={<ClienteForm />} />
            <Route path="Periodos" element={<PeriodosAdmin />} />
            <Route path="Periodos/crear" element={<PeriodoForm />} />
            <Route path="Periodos/editar/:id" element={<PeriodoForm />} />
            <Route path="ordenes" element={<OrdenesServicioAdmin />} />
            <Route path="ordenes/crear" element={<OrdenServicioForm />} />
            <Route path="ordenes/editar/:id" element={<OrdenServicioForm />} />
            <Route path="ordenes/:id/detalle/crear" element={<OrdenDetalleForm />} />
            <Route path="ordenes/:id/asignar-trabajador" element={<AsignarTrabajadorForm />} />
            <Route path="tablero" element={<TableroControl />} />  {/* Nueva ruta para el Tablero de Control */}
            <Route path="aprobar" element={<AprobarServiciosAdmin />} />
            <Route path="aprobar-negocios" element={<AprobarNegocios />} />
            <Route path="admin-tools" element={<AdminTools />} />
            <Route path="liquidacion" element={<LiquidacionAdmin />} />
            <Route path="pagos" element={<PagosAdmin />} />
            <Route path="tracking" element={<TrackingDashboardEnhanced />} />
            <Route path="suscripcion" element={<MiPlan />} />
            <Route path="suscripcion/confirmacion" element={<ConfirmacionPago />} />
            <Route path="delivery/:id" element={<DeliveryRuta />} />
            <Route path="ordenes/:id_orden/trazabilidad" element={<TrazabilidadOrden />} />
        </Route>

                </Routes>
              </Router>
            </SocketProvider>
              </CamposDinamicosProvider>
            </ConfigEmpresaProvider>
          </EstadosProvider>
        </EmpresaProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
